import React from "react";
import ShrinkChar from "../hero-chr/hero-chr.component";
import Wrapper from "./shrink-text-compoenent.styles";
import { useState } from "react";
import { motion, useAnimationControls } from "framer-motion";
import { useAppContext } from "../../layout/layout";

const ShrinkText = ({ text }) => {
  const { isDarkTheme } = useAppContext();
  const [isDisplay, setIsDisplay] = useState(false);
  const controls = useAnimationControls();

  const textArr = text.split("");

  const shrinkAni = () => {
    controls.start({
      transform: [
        "scale3d(1,1,1)",
        "scale3d(1.4,.55,1)",
        "scale3d(.75,1.25,1)",
        "scale3d(1.25,.85,1)",
        "scale3d(.9,1.5,1)",
        "scale3d(1,1,1)",
      ],
      transition: {
        duration: 2,
      },
    });
    setIsDisplay(true);
  };

  return (
    <Wrapper>
      <motion.h1
        className={`shrink-chr ${isDarkTheme ? "dark " : "light"}`}
        animate={controls}
        onMouseOver={() => !isDisplay && shrinkAni()}
        onAnimationComplete={() => setIsDisplay(false)}
      >
        {/* {text} */}
        {textArr.map((char, index) => {
          return char;
          // <ShrinkChar key={index} char={char} />
        })}
      </motion.h1>
    </Wrapper>
  );
};
export default ShrinkText;
